import { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const FocusContext = /*#__PURE__*/createContext(undefined);
export const FocusProvider = ({
  children,
  onFocus,
  onBlur
}) => {
  const [hasBeenFocused, setHasBeenFocused] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const isFocusedRef = useRef(false);
  const handleFocus = useCallback(event => {
    setHasBeenFocused(true);
    setIsFocused(true);
    isFocusedRef.current = true;
    onFocus(event);
  }, [onFocus]);
  const handleBlur = useCallback(event => {
    setIsFocused(false);
    isFocusedRef.current = false;
    onBlur(event);
  }, [onBlur]);
  const value = useMemo(() => ({
    hasBeenFocused,
    isFocused,
    isFocusedRef,
    onFocus: handleFocus,
    onBlur: handleBlur
  }), [handleBlur, handleFocus, hasBeenFocused, isFocused]);
  return /*#__PURE__*/_jsx(FocusContext.Provider, {
    value: value,
    children: children
  });
};
export const useFocusContext = () => {
  const context = useContext(FocusContext);
  if (context === undefined) {
    throw new Error('useFocusContext must be used within a FocusProvider');
  }
  return context;
};